import message from "@/utils/globalMessage";
import React, { PureComponent, Suspense } from 'react';

import _ from "lodash";
import actions from "@redux/water/actions";
import { connect } from "react-redux";
import { api } from "@redux/api";
import { Button, Form, Collapse, Space } from "antd";
import { WaterColumns, WaterProps } from "@containers/UtilityData/Water/WaterColumns";
import { WaterFormFields, WaterRelated } from "@containers/UtilityData/Water/WaterFormFields";
import { Spinner } from "@components/Spinner";
import EditableTable from "@components/Table/EditableTable";
import UtilityDualAxes from "@containers/UtilityData/Charts/UtilityDualAxes.js";
import moment from "moment";
import EditableTableActions from "@redux/EditableTable/actions";

import { WaterFilters } from "@containers/UtilityData/Water/WaterFilter";
import { CertifyStatus } from "@containers/UtilityData/CertifyStatus";
import queryString from "query-string";
import { withRouter } from '@/router/withRouter';
import { useKeepAliveContext } from '@/hooks/use-keep-alive-context';
import { useIsAssignTo } from '@/hooks/use-is-assign-to';
import { emitEvent, EventName, useEventBus } from '@/hooks/useEventBus';
import { useAuth, useAuthEditable, useAuthFullAccess } from '@/hooks/use-auth';
import { useSmartNavigate } from '@/hooks/use-smart-navigate';
import { buildFacilityPath, getFacilityContext } from '@/utils/route-context';
import { useSelector } from 'react-redux';
import Select from "@components/ResponsiveSelect";
import DatePicker from "@components/ResponsiveDatePicker";

const Histgram = React.lazy(() =>
    import("@containers/UtilityData/Charts/Histgram.js")
)
const LineChart = React.lazy(() =>
    import("@containers/UtilityData/Charts/LineChart.js")
)

const { Panel } = Collapse;
const { Option } = Select;

class Water extends PureComponent {
    actionRef = React.createRef();
    constructor(props) {
        super(props);
        this.tableRef = React.createRef();

        this.filterFormRef = React.createRef();
        this.state = {
            data: [],
            filter_dates: [],
            selected_months: [],
            selected_id: [],
            isLoading: false,
            tableRef: null,
            Selected_Rows: [],
            bulkLoading: false
        }
    }

    componentDidMount() {
        const params = queryString.parse(this.props.location.search);
        if (params?.status) {
          this.setState({
            status: params.status,
          });
        }
        if (params?.modify_date) {
            this.setState({
              modify_date: [
                moment().subtract(params?.modify_date, "days"),
                moment(),
              ],
            });
          }
    }

    componentDidUpdate(prevProps) {
        const selected_months = this.state.data
            .filter(e => this.state.Selected_Rows.includes(e.id))
            .map(e => moment(e.service_month).format('YY-MMM'));

        if (!_.isEqual(selected_months, this.state.selected_months)) {
            this.setState({ selected_months });
        }
    }

    handleCreateWater = (body) => {
        return api.createWater(body).then(
            response => {
                // console.log('create', response);
                return response.data
            }
        ).catch(error => (
            error
        ));
    }

    handleDeleteWater = (id) => {
        return api.deleteWater(id).then(
            response => {
                return response.data
            }
        ).catch(error => (
            error
        ));
    }

    handleBulkInsert = (body) => {
        // Force imported rows to be uncertified.
        const processedBody = body.map(item => ({
            ...item,
            is_eui_certified: false
        }));
        return api.bulkWaterInsert(processedBody).then(
            response => {
                return response.data
            }
        ).catch(error => {
            return (
                error
            )
        });
    }

    handleBulkDelete = (body) => {
        return api.bulkDeleteWater(body).then(
            response => {
                return response.data
            }
        ).catch(error => (
            error
        ));
    }

    handOnlineSave = (key, row) => {
        if (key < 0) {
            this.handleCreateWater(row)
        } else {
            return api.editWater(key, row).then(
                response => {

                    return response
                }
            ).catch(error => (
                error
            ));
        }

    }


    handleFilter = (query) => {
        this.setState({
            isLoading: true
        })
        let query_new = query +
            (this.state.filtered_startModifiedDate ? ('&start_month=' + (this.state.filtered_startModifiedDate)) : '') +
            (this.state.filtered_endModifiedDate ? ('&end_month=' + (this.state.filtered_endModifiedDate)) : '') + 
            (this.state.status ? ('&status=' + (this.state.status)) : '') + 
            (this.state.modify_date?.[0]
                ? "&modify_date_start=" +
                moment(this.state.modify_date[0]).format("YYYY-MM-DD")
                : "") +
              (this.state.modify_date?.[1]
                ? "&modify_date_end=" +
                moment(this.state.modify_date[1]).format("YYYY-MM-DD")
                : "");

        return api.filterWater(query_new).then(
            response => {
                let dataSource = response.data.results
                return {
                    data: dataSource,
                    success: true,
                    total: response.data.count
                }
            }
        ).catch(error => (
            error
        ));
    }

    getWater = (data) => {
        this.setState({
            data,
            isLoading: false
        })
        this.props.setWaterSuccess(data)
    }

    setFilterDates = (dates) => {
        this.setState({
            filter_dates: dates
        })

    }

    handleChartSelect = (e) => {
        this.setState({
            selected_months: [e]
        })
        let id = _.get(this.state.data.filter(f => moment(f['service_month']).format('YY-MMM') === e)[0], 'id')
        this.setState({
            selected_id: id
        })
    }

    setFilters = (e) => {
        this.setState({
            filtered_startModifiedDate: e.startModifiedDate ? moment(e.startModifiedDate).format('YYYY-MM-DD') : [],
            filtered_endModifiedDate: e.endModifiedDate ? moment(e.endModifiedDate).format('YYYY-MM-DD') : [],
        }, function () {
            this.refresh(false)
        })
    }

    renderFilter = () => {
        return <WaterFilters
            handleFilter={this.setFilters}
        />
    }

    refresh = (needRequest) => {
        return this.tableRef?.current?.refresh(needRequest);
    };

    gettableRef = (tableRef) => {
        this.setState({
            tableRef
        })
    }

    onSubmit = (rows) => {
        console.log('submit', rows)
    }

    onBulkUpdateEuiStatus = (rows, status) => {
        // Filter rows that need the target certification status.
        const filteredRows = rows.filter(row => {
            if (status) {
                // Certify only uncertified rows.
                return !row.is_eui_certified;
            } else {
                // Uncertify only certified rows.
                return row.is_eui_certified;
            }
        });

        if (filteredRows.length === 0) {
            const actionText = status ? 'certify' : 'uncertify';
            message.warning(`No records available to ${actionText}.`);
            return;
        }

        this.setState({ bulkLoading: true });

        api.updateEuiCertified('water', {
            ids: filteredRows.map(row => row.id),
            certified: status
        }).finally(() => {
            this.setState({ bulkLoading: false });
            this.refresh()
            emitEvent(EventName.UPDATE_CERTIFICATION_STATUS)
            emitEvent(EventName.REFRESH_CERTIFY_REQUEST)
            if (this.actionRef && this.actionRef.current) {
                const tableRef = this.actionRef.current;
                if (tableRef.clearSelected) {
                    tableRef.clearSelected();
                }
            }
        })
    }

    renderCustomButton = (rows) => {
        const { isAssignTo } = this.props;
        const { bulkLoading } = this.state;
        if (!isAssignTo) {
            return null;
        }
        return <Space>
            <Button 
                onClick={() => this.onBulkUpdateEuiStatus(rows, true)}
                loading={bulkLoading}
                disabled={bulkLoading}
            >
                Certify
            </Button>
            <Button 
                onClick={() => this.onBulkUpdateEuiStatus(rows, false)}
                loading={bulkLoading}
                disabled={bulkLoading}
            >
                Uncertify
            </Button>
        </Space>
    }

    resetFilters = () => {
        this.setState(
          {
            status: "",
            modify_date: [],
          },
          function () {
            if (this.filterFormRef && this.filterFormRef.current) {
              this.filterFormRef.current.resetFields();
            }
            this.actionRef.current.reset();
          }
        );
      };

      handleSearchSelect = (e, type) => {
        this.setState(
          {
            [type]: e,
            limit: null,
          },
          function () {
            this.actionRef.current.reset();
          }
        );
      };

      onDateChange = (dates, state) => {
        this.setState(
          {
            [state]: dates ?? [],
          },
          function () {
            this.actionRef.current.reset();
          }
        );
      };

      renderSearches = () => {
        return (
          <Form
            ref={this.filterFormRef}
            className={"filter-form"}
            initialValues={{
              status: Array.isArray(this.state.status)
                ? this.state.status
                : typeof this.state.status === "string"
                  ? this.state.status?.split(",")
                  : null,
            }}
          >
            <Form.Item label={"Status"} name="status">
              <Select
                allowClear
                placeholder={"Status"}
                options={Object.keys(CertifyStatus).map((item) => ({
                  label: CertifyStatus[item],
                  value: item,
                }))}
                onChange={(e) => this.handleSearchSelect(e, "status")}
              />
            </Form.Item>

            <Form.Item label={"Modify Date"} name="modify_date">
              <DatePicker.RangePicker
                value={this.state.modify_date}
                onChange={(dates) =>
                  this.onDateChange(dates, "modify_date")
                }
              />
            </Form.Item>
          </Form>
        );
      };

      getActionRef = (actionRef) => {
        this.actionRef.current = actionRef.current;
      }

    render() {
        const colors = [
            '#A52A2A',  // 棕色
            '#ADD8E6',  // light blue
            '#33FF57',
            '#FF33A1',  // 明亮的粉红色
            '#F1C40F'   // bright yellow
        ];

        const years = [...new Set(this.state.data.map(item => item.service_month.split('-')[0]))].sort((a, b) => a - b);
        const items = years.map(year => {
            const color = colors[+year % colors.length];
            return {
                name: year,
                value: year,
                marker: {
                    symbol: 'circle',
                    style: { fill: color }
                }
            }
        });
        items.push({
            name: 'selected',
            value: 'selected',
            marker: {
                symbol: 'circle',
                style: { fill: '#1890ff' }
            }
        })
        return (
            <>

                <Suspense fallback={<Spinner />}>
                    {/* <Suspense fallback={<Spinner />}>
                        <Collapse defaultActiveKey={['col1', 'col0']} ghost>
                            <Panel key={'col0'} header={<Divider />}>
                                <Row className={'w-full px-5'}>
                                    <Col xs={24} md={12} xl={8} className={''}>
                                        <div className={'mr-4'}>
                                            <Histgram
                                                key="WaterHistgram"
                                                area={this.props.Area}
                                                data={this.state.data}
                                                selected={this.state.selected_months}
                                                container='NormalizedWater'
                                                title='Normalized Water Use Vs. Weather'
                                                handleChartSelect={this.handleChartSelect}
                                                leftTitle={'KGal / sqft'}
                                                leftVar={'KGalSqft'}
                                                height={232}
                                                pointSize={6}
                                                legend={{
                                                    position: 'top-right',
                                                    items,
                                                }}
                                                color={({ Month }) => {
                                                    const year = Month.split('-')[0];
                                                    return colors[year % colors.length]
                                                }}
                                                isWeatherChart={true}
                                            />
                                        </div>
                                    </Col>
                                    <Col xs={24} md={12} xl={8} className={' p-6 mb-4'}>
                                        <div className={'mr-4'}>
                                            <UtilityDualAxes
                                                height={216}
                                                data={this.state.data}
                                                selected={this.state.selected_months}
                                                handleChartSelect={this.handleChartSelect}
                                                x={'service_month'}
                                                y={['usage', 'costs']}
                                                container='WaterCosts'
                                                title='Water Consumption and Costs'
                                                leftTitle='KGal'
                                                rightTitle='KGal'
                                                color={'blue'}
                                            />
                                        </div>
                                    </Col>
                                    <Col xs={24} md={12} xl={8} className={' p-6 mb-4'}>
                                        <div className={''}>
                                            <LineChart
                                                height={232}
                                                data={this.state.data}
                                                selected={this.state.selected_months}
                                                handleChartSelect={this.handleChartSelect}
                                                x={'service_month'}
                                                y={['costs', 'usage']}
                                                container='WaterPrices'
                                                title='Monthly Water Prices'
                                                leftTitle=''
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            </Panel>
                        </Collapse>
                    </Suspense> */}
                    <EditableTable
                        key={'Water'}
                        ref={this.tableRef}
                        columns={WaterColumns(this.refresh, this.props.isAssignTo, this.props.editable)}
                        data={this.state.data}
                        columnProps={WaterProps}
                        formFields={WaterFormFields(this.state.tableRef)}
                        formRelated={WaterRelated}
                        getRecord={this.getWater}
                        createRecords={this.handleCreateWater}
                        deleteRecord={this.handleDeleteWater}
                        bulkInsert={this.handleBulkInsert}
                        bulkDelete={this.handleBulkDelete}
                        handOnlineSave={this.handOnlineSave}
                        handleFilter={this.handleFilter}
                        setSelectedRows={(rows) => this.setState({ Selected_Rows: rows })}
                        // postComment={this.handlePostComment}
                        resetFilters={this.resetFilters}
                        renderFilter={this.renderFilter}
                        customButton={this.renderCustomButton}
                        relatedList={this.props.relatedList}
                        filter_dates={this.state.filter_dates}
                        setFilterDates={this.setFilterDates}
                        isRowClickable={false}
                        hide_search={true}
                        hid_new={!this.props.editable}
                        hide_imports={!this.props.editable}
                        selected_row={this.state.selected_id}
                        textAlign={'table-text-right'}
                        isChat={false}
                        isRelated={false}
                        isAttachments={false}

                        getFormRef={this.gettableRef}
                        renderSearches={this.renderSearches}
                        getActionRef={this.getActionRef}
                        canDelete={this.props.fullAccess}
                        editable={this.props.editable}
                        new_text={'Create Water'}
                        onNew={() => this.props.navigate(this.props.createWaterPath)}
                        onDoubleClick={(record) => {
                            this.props.navigateAndCloseTabs(this.props.getWaterDetailPath(record.id), {
                                viewType: 'facility',
                                leafPrefix: 'water-detail/',
                            });
                        }}
                    />
                </Suspense>

            </>
        );
    }
}

const mapStateToProps = state => {
    const role = Object.keys(_.get(state, 'Auth.role') || {})?.[0];
    const isAdmin = role === '1.0' || role === '2.1';
    return {
        Water: _.get(state.Water, 'data'),
        Area: _.get(state.Facility.selected, 'record.area'),
        isAdmin,
    }
}
const mapDispatchToProps = dispatch => {
    return {
        setWaterRequest: (e) => dispatch(actions.WaterRequest(e)),
        setWaterSuccess: (e) => dispatch(actions.WaterSuccess(e)),
    }
}

const withHooks = (Component) => {
    const NewComponent = (props) => {
  
      const { closeTab } = useKeepAliveContext()
      const { isAssignTo } = useIsAssignTo();
      const editable = useAuthEditable('water');
      const fullAccess = useAuthFullAccess('water')
      const facilityContext = useSelector((state) => getFacilityContext(state));
      const WaterListPath = buildFacilityPath('water', facilityContext) || '/switch-view';
      const createWaterPath = buildFacilityPath('create-water', facilityContext) || '/switch-view';
      useEventBus(EventName.CLOSE_WATER, () => {
        closeTab(WaterListPath)
      })
  
      const { navigateAndCloseTabs } = useSmartNavigate();
      const getWaterDetailPath = (id) => buildFacilityPath(`water-detail/${id}`, facilityContext) || WaterListPath;

      return (
        <Component
          {...props}
          isAssignTo={isAssignTo}
          editable={editable}
          fullAccess={fullAccess}
          navigateAndCloseTabs={navigateAndCloseTabs}
          createWaterPath={createWaterPath}
          getWaterDetailPath={getWaterDetailPath}
        />
      )
    }
    return NewComponent
  }

export default withHooks(withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(Water)));
